// extracted by mini-css-extract-plugin
export default {"requirements":"root_bottom-module__requirements___IUGyj","copyright":"root_bottom-module__copyright___qKKVW","requirementsLink":"root_bottom-module__requirementsLink___IOdzN"};